import React, { MouseEventHandler } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

export type ConfirmationDialogProps = {
  open: boolean;
  onClose?: MouseEventHandler;
  onConfirm?: MouseEventHandler;
  dialogText?: string;
};

export const ConfirmationDialog = ({ open, onClose, onConfirm, dialogText }: ConfirmationDialogProps): JSX.Element => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-testid="alert-dialog"
    >
      <DialogTitle id="alert-dialog-title" data-testid="alert-title">
        ARE YOU SURE?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{dialogText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} color="primary" data-testid="cancel-action" aria-label="cancel-delete">
          Cancel
        </Button>
        <Button
          variant="text"
          onClick={onConfirm}
          color="primary"
          autoFocus
          data-testid="confirm-action"
          aria-label="confirm-delete"
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
